import * as React from "react";
import * as ReactDOM from "react-dom";

import pureRender from "pure-render-deepcompare-decorator";
import * as classnames from "classnames";
import * as styles from "./BindFriends.scss";
import {IRanksInfo,IEntrys,IUserInfo} from "../..//IViewObject";
import {voteTicket,bindFriend} from "../../utils/fetch";
import * as subpub from "../../utils/subpub";
import {Dialog} from "../../components";

export interface IBindFriendsProps{
    /**class */
    className?:string;
    historyBindUser:IRanksInfo[],
    curBindUser:IRanksInfo,
    confData:IEntrys[],
    userInfo:IUserInfo
}
export interface IBindFriendsState{
    left:number,
}
@pureRender
export class BindFriends extends React.Component<IBindFriendsProps,IBindFriendsState>{
    constructor(props){
        super(props);
        this.state={
            left:0
        }   
    }
    // componentWillReceiveProps(nextProps) {
    //     if(!!nextProps.curBindUser.yyuid){   
    //         f2eGame.port.udb.getUserInfo()
    //         .then((res)=>{
    //             this.setState({passport:res.passport})                 
    //         })
    //     }
    // }
    componentWillUpdate() {
		// requestAnimationFrame(this.resolveAnimationFrame);
    }
    public render(){
        const {className,historyBindUser,curBindUser} =this.props;
        const {left}=this.state;
        const classNameSec=classnames(styles.sec,className);
        return (
            <div className={classNameSec}>
                <div className={styles.btn_left} onClick={(e)=>(this.resolveAnimationFrame("left"))}></div>
                <div className={styles.content}>                    
                    <ul style={{left:left}}>
                        {this.renderCurBind()}
                        {historyBindUser.map((item,index)=>this.renderHistory(item,index))}
                        
                        <li>
                            <div className={styles.add_pic}></div>
                        </li>
                    </ul>                  
                </div>
                <div className={styles.btn_right} onClick={(e)=>(this.resolveAnimationFrame('right'))}></div>
                
            </div>
        )
    }

    private renderCurBind=()=>{
        const {curBindUser}=this.props;
        if(!!curBindUser.yyuid){     
            return (
                <li>
                    <div className={styles.cur}></div>
                    <div className={styles.totalticket}>累计支持：<span>{curBindUser.scores}</span></div>
                    <div className={styles.friend_pic}  title={curBindUser.nickname}>
                        <img src={"http://image.open.yy.com/avatar/"+curBindUser.yyuid} alt="" width="84" height="84"/>
                        <div className={styles.pic_mask}></div>
                    </div>
                    <div className={styles.btn_send} onClick={this.voteTicket}></div>
                </li>
            )
        }
    }
    private renderHistory(item ,index){
        if(!!item.yyuid){

            return (
                <li>
                    <div className={styles.nocur}></div>                            
                    <div className={styles.totalticket}>累计支持：<span>{item.scores}</span></div>
                    <div className={styles.friend_pic} title={item.nickname}>
                        <img src={"http://image.open.yy.com/avatar/"+item.yyuid} alt="" width="84" height="84"/>
                        <div className={styles.pic_mask}></div>
                    </div>
                    <div className={styles.btn_changebind} onClick={(e)=>(this.changeBind(item.yyuid))}></div>
                    
                </li>
            )
        }else{
            return null
        }
    }
    private voteTicket=()=>{
        let {userInfo, confData} =this.props;
        if(this.props.userInfo.tickets==0){
            let tasksNum=0;
            let tasks=[],games=[],servers=[],x=[],y=[];
            confData.map((item,index)=>{
                item.tasks.map((task,i)=>{
                    if(task.taskStatus!=100){
                        tasksNum++;
                        tasks.push(task);
                        games.push(item.gameId);
                        servers.push(item.serverId);
                        x.push(index);
                        y.push(i)
                    }
                })
            })
            if(tasksNum>0){
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:`您当前没有支持度，<br/>体验游戏即可获得支持度哦！`,
                    buttons:[{
                        className:'btn-getAward',
                        callback:()=>{

                            let options={
                                taskId:tasks[0].id,
                                gameId:games[0],
                                serverId:servers[0],
                                taskName:tasks[0].showName,
                                x:x[0],
                                y:y[0],
                                noTips:true,
                                isClick:false
                            }
                            subpub.emit('getTaskAward',options);
                            dialog.close(true)
                        }
                    }]
                })
            }else{
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:`本日已完成全部任务，请明日再接再厉~`,
                    buttons:[{
                        className:'btn-y',
                        callback:()=>{
                            dialog.close(true)
                        }
                    }]
                })
            }
        }else{

            let cont=""
            voteTicket()
            .then((res:any)=>{
                if(res.status==200&&res.data==true){
                    cont="投票成功";
                    subpub.emit('voteSucc')
                }else{
                    cont="投票失败";
                }
    
                let dialog=new f2eGameUI.Dialog({
                    classNames:{
                        component:"min-pop"
                    },
                    content:cont,
                    buttons:[{
                        className:"btn-y",
                        callback:()=>{
                            dialog.close(true)
                        }
                    }]
                })
            })
        }
    }


    // 更换绑定、

    private changeBind=(yyuid)=>{
        // this.setState({curYyuid:yyuid,searchValue:passport});
        
                let shareYyuid=Number(yyuid);
                let curBindYyuid=this.props.curBindUser.yyuid;
                if(!!shareYyuid){
                  if(curBindYyuid==shareYyuid) return;
                                   
                  let dialog=new f2eGameUI.Dialog({
                    classNames:{
                      component:"min-pop"
                    },
                   buttons:[{
                     className:"btn-nobind",
                     callback:()=>{
                        dialog.close(true)
                     }
                   },{
                     className:"btn-bind",
                     callback:()=>{
                      this.bind(shareYyuid)
                      dialog.close(true)
                      
                     }
                   }]
                  })
                  let contTips="";
                  if(!!curBindYyuid){
                     contTips=`是否解除已有绑定，并绑定${shareYyuid}为您新的游戏大使？`;            
                  }else{
                     contTips=`是否绑定TA为您的游戏大使。绑定后将自动支持TA`;            
                    
                  }
                  ReactDOM.render(
                    <Dialog shareYyuid={shareYyuid} curBindYyuid={curBindYyuid} contTips={contTips}/>,
                    $('.f2e-dialog__body ')[0]
                  )
                }
              
                
            }
            private bind(yyuid){
                bindFriend(yyuid)
                .then((res:any)=>{
                    let cont="";
                    if(res.status==200&&res.data){
                        cont="绑定成功！";
                        subpub.emit('bindSucc');
                        
                    }else if(res.status==551){
                        cont=res.message;
                    }else{
                        cont="绑定失败！";
                    }
                    let dialog=new f2eGameUI.Dialog({
                        classNames:{
                            component:"min-pop"
                        },
                        content:cont,
                        buttons:[{
                            className:"btn-y",
                            callback:()=>{
                                dialog.close(true)
                            }
                        }]
                    })
                })
            }
    resolveAnimationFrame=(dec:string)=> {
        let length=this.props.historyBindUser.length;
        // let length=4;
        if(!!this.props.curBindUser.yyuid && length>2){
            let width=(length-1)*156;
            if(dec=="right"){
                if(this.state.left==-width){
                    return
                }
                let move=0;
                let timer=setInterval(()=>{
                    if(this.state.left>-width&&move<156) {
                        this.setState({
                            left: this.state.left -1
                        });
                        move++;
                    }else{
                        clearInterval(timer)
                    }
                },1)
            }else{
                if(this.state.left==0){
                    return
                }
                let move=0;
                let timer=setInterval(()=>{
                    if(this.state.left<width&&move<156) {
                        this.setState({
                            left: this.state.left +1
                        });
                        move++;
                    }else{
                        clearInterval(timer)
                    }
                },1)
            }
        
        }else{
            return;
        }
	}

    
}

export default BindFriends;


// WEBPACK FOOTER //
// ./src/components/BindFriends/BindFriends.tsx